import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowLeftIcon } from "feather-icons/dist/icons/arrow-left.svg";
import { ReactComponent as ArrowRightIcon } from "feather-icons/dist/icons/arrow-right.svg";

/** Navigation article précédent (plus ancien) / suivant (plus récent). */

const Nav = tw.nav`mt-12 flex flex-col sm:flex-row`;
const Item = styled(Link)(({ $align }) => [
  tw`flex-1 flex flex-col rounded-lg bg-gray-100 p-6 transition duration-300 hocus:bg-gray-200 focus:outline-none focus:shadow-outline`,
  tw`mt-4 sm:mt-0 first:mt-0`,
  $align === "right" ? tw`sm:ml-4 sm:text-right sm:items-end` : tw`sm:mr-4 sm:text-left`,
]);
const Label = styled.span`
  ${tw`inline-flex items-center uppercase text-xs font-bold tracking-widest text-gray-600`}
  svg {
    ${tw`w-4 h-4 text-primary-500`}
  }
`;
const Title = tw.span`mt-2 font-bold text-gray-900 leading-snug`;
const Spacer = tw.div`flex-1 sm:ml-4`;
const LeftIcon = tw(ArrowLeftIcon)`mr-2`;
const RightIcon = tw(ArrowRightIcon)`ml-2`;

export default function PrevNext({ older, newer }) {
  if (!older && !newer) return null;
  return (
    <Nav aria-label="Autres articles">
      {older ? (
        <Item to={`/blog/${older.slug}`} $align="left" rel="prev">
          <Label>
            <LeftIcon aria-hidden="true" />
            Article précédent
          </Label>
          <Title>{older.title}</Title>
        </Item>
      ) : (
        <Spacer aria-hidden="true" />
      )}
      {newer ? (
        <Item to={`/blog/${newer.slug}`} $align="right" rel="next">
          <Label>
            Article suivant
            <RightIcon aria-hidden="true" />
          </Label>
          <Title>{newer.title}</Title>
        </Item>
      ) : (
        <Spacer aria-hidden="true" />
      )}
    </Nav>
  );
}
